import React, {useState} from "react";
import Link from "next/link";

const Weddings: React.FC = ({ children }) => {
  const [themeValue, setthemeValue] = useState<number>(1)

  const toggleTheme = (x) => {
    if(x === 'up'){
      themeValue < 17 ? setthemeValue(themeValue + 1) : setthemeValue(1)
    } else {
      themeValue > 1 ? setthemeValue(themeValue - 1) : setthemeValue(17)
    }
  }

  return(
    <>
<section id="venue-hero">
      <div className="cover-shape"></div>
      <div className="content-container maxw1350">
        <h1>TacBoard for Fundraisers</h1>
        <p>Add seamless fun to your fundraiser while collecting valuable pics of your guests and supporters enjoying the event.</p>
        <Link href="/tacboard-pricing">
            <a className="get-tac-now">Get TacBoard Now</a>
        </Link>
      </div>
      <div className="bottom-wave"></div>
    </section>

<section className="events-description">
  <div className="content-container">
    <h2>Set up TacBoard at your fundraiser and create easy and fun entertainment for your guests and supporters all while building an amazing album of candid photos you can later use for internal purposes, on your social media, or just to enjoy.</h2>
  </div>
</section>



    <section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>All Inclusive<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-corp-remote.png" alt="TacBoard Fundraisers from anywhere" />
          </picture>
        </div>
        <div className="half">       
        <p>
        Easily include remote supporters by sharing your gallery link and Live Stream link, where they’ll be able to see all the great pics flowing in and contribute their own.
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>

<section className="includes">
      <h2 className="center">
        <span className="line"></span>Ask and You Shall Receive<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-corp-sign.png" alt="TacBoard Party Signs" />
          </picture>
          <div className="view-themes-container">
            <div className="view-themes-btn" onClick={() => toggleTheme('down')}> {`<`} </div>
            <div className="view-theme-text">View Themes</div>
            <div className="view-themes-btn"onClick={() => toggleTheme('up')}> {`>`} </div>
            </div>
        </div>
        <div className="half">      
        <p>
        Place some signs around at the event space asking guests to take specific photos, or selfies and text them to your TacBoard number. 
          </p>
        </div>
      </div>
    </section>

<section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>Make Photo Fun<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
          <picture>
          <>
          {/* <source type="image/webp" srcSet={`
                img/gallery-theme-${themeValue}.webp,
                img/gallery-theme-${themeValue}.webp 2x
              `} media="(min-width: 801px)" />
            <source type="image/webp" srcSet={`
                img/gallery-theme-${themeValue}.webp,
                img/gallery-theme-${themeValue}.webp 2x
              `} media="(max-width: 800px)" />

            <source type="image/jpg" srcSet={`
                img/gallery-theme-${themeValue}.jpg,
                img/gallery-theme-${themeValue}.webp 2x
              `} media="(min-width: 801px)" />
            <source type="image/jpg" srcSet={`
                img/gallery-theme-${themeValue}.jpg,
                img/gallery-theme-${themeValue}.webp 2x
              `} media="(max-width: 800px)" /> */}

            <img src={`img/events-corp-props.png`} alt="TacBoard Photo Props"/></>
          </picture>
        </div>
        <div className="half">
          <p>
          Make a photo station at your fundraiser with fun props and a sign asking guests to snap some fun pics and text them to your TacBoard phone number
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>

    <section className="includes">
      <h2 className="center">
        <span className="line"></span>So Easy, So Wonderful<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
          <p>
          You will seamlessly collect hundreds of candid photos from your fundraiser of your guests and supporters having fun, which you can later use in internal newsletters, recruiting, marketing, and social media to show off the great support you have for your cause.
          </p>
        </div>
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="img/sign-shop-sign-selfie-station.webp
                        " />
            <source type="image/jpg" srcSet="img/sign-shop-sign-selfie-station.jpg
                    " /> */}

            <img src="img/events-corp-gallery.png" alt="TacBoard Corporate Events Photo Gallery" />
          </picture>
        </div>
      </div>
    </section>

<section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>Easy, Fun & Fabulous<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
          <p>
          Easily add some fun interaction to your fundraiser that guests will love but is also not dominating, distracting, or obnoxious.
          </p>
        </div>
        <div className="half">
        <video disableRemotePlayback className="thumb-vid" muted loop autoPlay preload="auto">
            <source src="img/av-live-screen.webm" type="video/webm" />
            <source src="img/av-live-screen.mp4" type="video/mp4" />
          </video>
        </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
      </div>
    </section>


<section className="events-description">
  <div className="content-container">
    <h2>Sign up and get TacBoard for your your fundraiser!</h2>
  </div>
</section>

    </>
)}

export default Weddings;
